import { __spreadValues } from './chunk-5JBD5THX.js';
import * as React from 'react';

var SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "0 0 16 16", fill: "none" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M3.33313 8.00002L13.3331 7.99986",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M5.99984 4.6666L3.37361 7.29283C3.04028 7.62616 2.87361 7.79283 2.87361 7.99994C2.87361 8.20704 3.04028 8.37371 3.37361 8.70704L5.99984 11.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
));
var ArrowLeft_default = SvgArrowLeft;

export { ArrowLeft_default };
